export default __webpack_public_path__ + "static/media/schemat3.b170000f.png";